// Day Mappings Middleware

import {
  FETCH_DAY_MAPPINGS,
  FETCH_DAY_MAPPINGS_SUCCESS,
  FETCH_DAY_MAPPINGS_ERROR,
  UPDATE_DAY_MAPPINGS,
  UPDATE_DAY_MAPPINGS_SUCCESS,
  UPDATE_DAY_MAPPINGS_ERROR,
  RESET_DAY_MAPPINGS,
  RESET_DAY_MAPPINGS_SUCCESS,
  RESET_DAY_MAPPINGS_ERROR,
} from "../dux/dayMappings";
import {
  getDayMappingsUrl,
  getUpdateDayMappingsUrl,
  getResetDayMappingsUrl,
} from "../helpers/apiEndPoints";
import { openSnackbar } from "../dux/snackbar";
import { apiAction, API_SUCCESS, API_ERROR } from "../dux/api";

export const dayMappingsMiddleware = (store) => (next) => (action) => {
  next(action);

  switch (action.type) {
    case FETCH_DAY_MAPPINGS:
      next(
        apiAction({
          url: getDayMappingsUrl(action.payload.location),
          feature: FETCH_DAY_MAPPINGS,
          method: "GET",
        })
      );
      break;

    case UPDATE_DAY_MAPPINGS:
      next(
        apiAction({
          url: getUpdateDayMappingsUrl(action.payload.location),
          feature: UPDATE_DAY_MAPPINGS,
          method: "PUT",
          data: { day_mappings: action.payload.dayMappings },
        })
      );
      break;

    case RESET_DAY_MAPPINGS:
      next(
        apiAction({
          url: getResetDayMappingsUrl(action.payload.location),
          feature: RESET_DAY_MAPPINGS,
          method: "POST",
        })
      );
      break;

    default:
      break;
  }
};

// Default export for the middleware
export default dayMappingsMiddleware;

// Handle API_SUCCESS and API_ERROR routed back from apiMiddleware
export const dayMappingsAfterware = () => (next) => (action) => {
  if (action.type === `${FETCH_DAY_MAPPINGS} ${API_SUCCESS}`) {
    next({
      type: FETCH_DAY_MAPPINGS_SUCCESS,
      payload: action.payload?.day_mappings,
    });
    return;
  }
  if (action.type === `${FETCH_DAY_MAPPINGS} ${API_ERROR}`) {
    next({
      type: FETCH_DAY_MAPPINGS_ERROR,
      payload:
        action.payload?.data?.response?.message ||
        "Failed to fetch day mappings",
    });
    next(
      openSnackbar({
        message:
          action.payload?.data?.response?.message ||
          "Failed to fetch day mappings",
        type: "error",
      })
    );
    return;
  }

  if (action.type === `${UPDATE_DAY_MAPPINGS} ${API_SUCCESS}`) {
    // Use the input mappings if response doesn't include them
    const updated = action.meta?.day_mappings || action.payload?.day_mappings;
    next({ type: UPDATE_DAY_MAPPINGS_SUCCESS, payload: updated });
    next(openSnackbar({ message: "Day mappings updated successfully!" }));
    return;
  }
  if (action.type === `${UPDATE_DAY_MAPPINGS} ${API_ERROR}`) {
    next({
      type: UPDATE_DAY_MAPPINGS_ERROR,
      payload:
        action.payload?.data?.response?.message ||
        "Failed to update day mappings",
    });
    next(
      openSnackbar({
        message:
          action.payload?.data?.response?.message ||
          "Failed to update day mappings",
        type: "error",
      })
    );
    return;
  }

  if (action.type === `${RESET_DAY_MAPPINGS} ${API_SUCCESS}`) {
    const defaultMappings = {
      monday: false,
      tuesday: false,
      wednesday: false,
      thursday: false,
      friday: false,
      saturday: true,
      sunday: true,
    };
    next({ type: RESET_DAY_MAPPINGS_SUCCESS, payload: defaultMappings });
    next(
      openSnackbar({ message: "Day mappings reset to default successfully!" })
    );
    return;
  }
  if (action.type === `${RESET_DAY_MAPPINGS} ${API_ERROR}`) {
    next({
      type: RESET_DAY_MAPPINGS_ERROR,
      payload:
        action.payload?.data?.response?.message ||
        "Failed to reset day mappings",
    });
    next(
      openSnackbar({
        message:
          action.payload?.data?.response?.message ||
          "Failed to reset day mappings",
        type: "error",
      })
    );
    return;
  }

  return next(action);
};
